import {call, put, takeLatest} from 'redux-saga/effects';
import overviewActions from '../actions/overview.actions';
import OverviewApi from '../api/OverviewApi';

function* fetchOverview(action) {
    try {
        const overview = yield call(OverviewApi.getOverviewData, action.payload);
        yield put(overviewActions.getHomeSuccess(overview));
    } catch (e) {
        yield put(overviewActions.getHomeFailed(e));
    }
}

function* overviewSaga() {
    yield takeLatest(overviewActions.TYPES.GET_HOME, fetchOverview);
}

export default overviewSaga;
